import React from 'react';
import styles from './index.module.less';
import Link from 'next/link';
import Image from 'next/image';

interface WhatDoViewProps {
  data: any;
  reverseSearchContent?: React.ReactNode;
}

/**
 * WhatDoView 共用组件
 * reverseSearchContent: 可选的搜索框内容，会在第二个卡片中显示
 */
export default function WhatDoView({ data, reverseSearchContent }: WhatDoViewProps) {
  const title = data?.contentInfo?.['section-what2']?.title || '';
  const cards = data?.contentInfo?.['section-what2']?.cards || [];

  // 渲染描述文本，将 links 中的 title 替换为可点击的链接
  const renderDesc = (text: string, links: { title: string; link: string }[]) => {
    if (!links || !links.length) return text;

    const parts: React.ReactNode[] = [];
    let remainingText = text;

    links.forEach((linkItem, index) => {
      const linkIndex = remainingText.indexOf(linkItem.title);
      if (linkIndex !== -1) {
        if (linkIndex > 0) {
          parts.push(remainingText.slice(0, linkIndex));
        }
        parts.push(
          <Link key={index} href={linkItem.link} target="_blank" rel="noopener noreferrer" className={styles.link}>
            {linkItem.title}
          </Link>,
        );
        remainingText = remainingText.slice(linkIndex + linkItem.title.length);
      }
    });

    if (remainingText) {
      parts.push(remainingText);
    }

    return parts.length > 0 ? parts : text;
  };

  // 渲染列表项，支持链接替换
  const renderListItem = (item: string, links: { title: string; link: string }[]) => {
    return renderDesc(item, links);
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>

      <div className={styles.stepsContainer}>
        {cards.map((card: any, index: number) => (
          <div className={styles.stepRow} key={index}>
            <div className={styles.iconColumn}>
              <div className={styles.iconWrapper}>
                {card.imgPath && <Image src={card.imgPath} alt={card.title} width={20} height={20} />}
              </div>
              <div className={styles.verticalLine} />
            </div>

            <div className={styles.contentColumn}>
              <h3 className={styles.stepTitle}>{card.title}</h3>
              {card.bodyText?.map((text: string, pIndex: number) => (
                <p className={styles.stepContent} key={pIndex}>
                  {renderDesc(text, card.links)}
                </p>
              ))}

              {/* 第二个卡片显示自定义搜索框内容 */}
              {index === 1 && reverseSearchContent && (
                <div className={styles.searchBoxPlaceholder}>{reverseSearchContent}</div>
              )}

              {card.items && card.items.length > 0 && (
                <ul className={styles.list}>
                  {card.items.map((item: string, idx: number) => (
                    <li key={idx} className={styles.listItem}>
                      {renderListItem(item, card.links)}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
